module.exports = __webpack_public_path__ + "img/qrcode.0ef2a7eb.png";